import { useFlashMessageStore } from "./store";
import { FlashMessage } from "@crunchyroll/cx-web-components";
import styles from "./flashMessageContainer.module.scss";

export const FlashMessageContainer = () => {
  const { flashMessage, clearFlashMessage } = useFlashMessageStore();

  if (!flashMessage) {
    return null;
  }

  return (
    <FlashMessage
      className={styles.flashMessageContainer}
      message={flashMessage.message}
      type={flashMessage.type}
      timeoutExpiration={flashMessage.timeout} onClose={clearFlashMessage}
    />
  )
}